"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserScopeToJSON = exports.UserScopeFromJSONTyped = exports.UserScopeFromJSON = exports.UserScope = void 0;
/**
 *
 * @export
 */
exports.UserScope = {
    CurrentUser: 'CURRENT_USER',
    SuperUser: 'SUPER_USER'
};
function UserScopeFromJSON(json) {
    return UserScopeFromJSONTyped(json, false);
}
exports.UserScopeFromJSON = UserScopeFromJSON;
function UserScopeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.UserScopeFromJSONTyped = UserScopeFromJSONTyped;
function UserScopeToJSON(value) {
    return value;
}
exports.UserScopeToJSON = UserScopeToJSON;
